module.exports = __webpack_public_path__ + "static/media/plus.3f9adb71.svg";